/* =====================================================================
   Buffalo Gears — own lightweight theme engine (no framework)
   Handles: cart (AJAX), variant selection + image/price swap, product
   media gallery, mobile nav drawer, quantity steppers, accordions.
   ===================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------
     Cart count helper — refresh the bubble after cart mutations
     --------------------------------------------------------------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------
     Add to cart (AJAX) — any <form action="/cart/add">
     --------------------------------------------------------------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"], form[data-cart-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          window.location.href = '/cart';
        })
        .catch(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        });
    });
  }

  /* ---------------------------------------------------------------
     Cart page — quantity change / remove via AJAX
     --------------------------------------------------------------- */
  function initCartLineItems() {
    document.querySelectorAll('[data-line-key]').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-line-key');
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 1;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () {});
      });
    });
  }

  /* ---------------------------------------------------------------
     Quantity steppers — buttons with data-qty-step
     --------------------------------------------------------------- */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty]');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(btn.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      if (v < min) v = min;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && v > max) v = max;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------------
     Variant picker — option radios/selects -> selected variant.
     Updates price, availability, URL, hidden id input + emits
     a "variant:change" event for the gallery.
     Expects: <variant-data type="application/json"> with variants.
     --------------------------------------------------------------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var form = document.getElementById(picker.getAttribute('data-form')) ||
        picker.closest('form') ||
        document.querySelector('form[data-cart-add]');

      function selectedOptions() {
        var opts = [];
        picker.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var checked = group.querySelector('input:checked, select');
          if (checked) opts[idx] = (checked.value || '').trim();
        });
        return opts;
      }

      function match(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update() {
        var variant = match(selectedOptions());
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        var atc = form ? form.querySelector('[type="submit"]') : null;

        // selected value labels
        picker.querySelectorAll('[data-selected-value]').forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-selected-value'), 10);
          var group = picker.querySelector('[data-option-index="' + idx + '"]');
          var checked = group ? group.querySelector('input:checked, select') : null;
          if (checked) el.textContent = checked.value;
        });

        // keep mobile mirror dropdowns in sync with the checked chip
        picker.querySelectorAll('[data-variant-select]').forEach(function (sel) {
          var g = sel.closest('[data-option-index]');
          var ch = g ? g.querySelector('input:checked') : null;
          if (ch && sel.value !== ch.value) sel.value = ch.value;
        });

        if (!variant) {
          if (atc) {
            atc.disabled = true;
            var missing = false;
            picker.querySelectorAll('[data-option-index]').forEach(function (group) {
              var sel = group.querySelector('input:checked, select');
              if (!sel || !(sel.value || '').trim()) missing = true;
            });
            atc.textContent = missing ? (atc.getAttribute('data-select-label') || 'Select a size') : 'Unavailable';
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? (atc.getAttribute('data-add-label') || 'Add to cart') : 'Sold out';
        }
        // price
        document.querySelectorAll('[data-price]').forEach(function (el) {
          el.textContent = money(variant.price);
        });
        document.querySelectorAll('[data-compare-price]').forEach(function (el) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = money(variant.compare_at_price);
            el.hidden = false;
          } else { el.hidden = true; }
        });
        // url
        if (picker.hasAttribute('data-update-url') && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
        // notify gallery
        document.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true, detail: { variant: variant }
        }));
      }

      picker.addEventListener('change', update);

      // mobile dropdowns mirror the (hidden) radio chips so the picker
      // reads the same source of truth on every viewport
      picker.querySelectorAll('[data-variant-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var g = sel.closest('[data-option-index]');
          if (!g) return;
          var esc = (window.CSS && CSS.escape) ? CSS.escape(sel.value) : sel.value.replace(/"/g, '\\"');
          var radio = g.querySelector('input[type="radio"][value="' + esc + '"]');
          if (radio) radio.checked = true;
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Product gallery — swap hero image on variant change
     --------------------------------------------------------------- */
  function initGalleryVariantSwap() {
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var src = (v.featured_image && v.featured_image.src) ||
        (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
      if (!src) return;
      var img = document.querySelector('[data-gallery-hero] img');
      if (!img) return;
      var sized = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
      img.setAttribute('src', sized);
      img.removeAttribute('srcset');
    });
  }

  /* ---------------------------------------------------------------
     Mobile navigation drawer
     --------------------------------------------------------------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    document.querySelectorAll('[data-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // sub-panel navigation inside the drawer
    drawer.querySelectorAll('[data-panel-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = drawer.querySelector('[data-panel="' + b.getAttribute('data-panel-open') + '"]');
        if (target) target.classList.add('is-active');
      });
    });
    drawer.querySelectorAll('[data-panel-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = b.closest('[data-panel]');
        if (panel) panel.classList.remove('is-active');
      });
    });
  }

  /* ---------------------------------------------------------------
     Accordions (<details> are native; this is for custom rows)
     --------------------------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion]');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ---------------------------------------------------------------
     Boot
     --------------------------------------------------------------- */
  function boot() {
    initAddToCart();
    initCartLineItems();
    initQtySteppers();
    initVariantPickers();
    initGalleryVariantSwap();
    initDrawer();
    initAccordions();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
